import { render, staticRenderFns } from "./notifications-container.vue?vue&type=template&id=a7fe1366"
import script from "./notifications-container.vue?vue&type=script&lang=ts"
export * from "./notifications-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports